import React, { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { nanoid } from "nanoid"

import { HiOutlineArrowNarrowLeft } from "react-icons/hi"
import { AiOutlineClockCircle } from "react-icons/ai"
import { FaAngleDown } from "react-icons/fa"
import { BiDish } from "react-icons/bi"
import Steps from "../../components/searchRecipes/Steps"
import Nutrition from "../../components/searchRecipes/Nutrition"
// import Ingredients from '../../components/searchRecipes/Ingredients'

function SearchRecipePage({ allRecipes, displayPage }) {
    const history = useHistory()
    const location = useLocation()
    const recipeId = Number(location.pathname.substr(14))
    const [ recipe, setRecipe ] = useState({})
    const [ displayNutrition, setDisplayNutrition ] = useState( false )
    const {
        title,
        image, 
        vegetarian,
        vegan,
        glutenFree,
        dairyFree,
        veryHealthy,
        servings,
        readyInMinutes,
        analyzedInstructions,
        nutrition,
        summary,
    } = recipe
    
    useEffect(() => {
        allRecipes.forEach( item => recipeId === item.id && setRecipe( item ) )
    }, [ allRecipes, recipeId ])

    const changeRoute = () => {
        history.goBack()
        displayPage()
    }

    const showNutrition = () => setDisplayNutrition( !displayNutrition )

    return (
        <>
            <button onClick={changeRoute}><HiOutlineArrowNarrowLeft size="20px"/></button>
            <article className="recipePage searchRecipePage">
                <header>
                    <section>
                        <h2>{title}</h2>
                        <div className="diets">
                            <span className={veryHealthy ? "details active" : "details"}>Healthy</span>
                            <span className={vegetarian ? "details active" : "details"}>Vegetarian</span>
                            <span className={vegan ? "details active" : "details"}>Vegan</span>
                            <span className={glutenFree ? "details active" : "details"}>Gluten Free</span>
                            <span className={dairyFree ? "details active" : "details"}> Dairy Free</span>
                        </div> 
                        <div>
                            <BiDish size="22px" /> 
                            <p>{servings} servings</p>
                        </div>
                        <div>
                            <AiOutlineClockCircle size="20px" /> 
                            <p>{readyInMinutes} minutes</p>
                        </div>
                    </section>
                    <img src={image} alt="Search Recipe" />
                </header>

                <div className="summary">
                    <p>{summary?.replace(/<\/?[^>]+>/gi, "")}</p>
                </div>

                <div className="nutritionInfo">
                    <div>
                        <h3>Nutrition Information</h3>
                        <button onClick={showNutrition}><FaAngleDown size="24px"/></button>
                    </div>
                    { displayNutrition && <Nutrition nutrition={nutrition} key={nanoid()}/> }
                </div>

                {/* <Ingredients ingredients={extendedIngredients} /> */}
                { analyzedInstructions?.map( item => <Steps steps={item.steps} key={nanoid()} /> ) }
            </article>
        </>
    )
}

export default SearchRecipePage
